<template>
  <div class="pop-video-modal">
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      :destroy-on-close="true"
      custom-class="pop-video-dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :modal="false"
      @close="handleClose"
      @closed="handleClosed"
    >
      <div class="cover-video">
        <div class="pop">
          <div class="pop-video">
            <video
              v-if="innerVideoUrl"
              ref="videoPlayer"
              class="my-video"
              :class="{ 'is-ready': isVideoReady }"
              :src="innerVideoUrl"
              autoplay
              :loop="false"
              :muted="false"
              controls
              @loadedmetadata="handleVideoReady"
              @canplay="handleVideoReady"
              @emptied="handleVideoReset"
              playsinline
              webkit-playsinline="true"
              x5-playsinline="true"
            ></video>
          </div>
          <i
            :class="['el-icon-error', 'error-icon', 'cursor-p']"
            @click="closeVideo"
            code-ga="event,PAGEURL, mob视频_关闭弹窗"
            code-stm="event, PAGEURL, mob视频_关闭弹窗"
          ></i>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PopVideo",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default: "",
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  data() {
    return {
      innerVideoUrl: "",
      isVideoReady: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.innerVideoUrl = this.videoUrl;
          this.isVideoReady = false;
          return;
        }
      },
    },
    videoUrl(value) {
      if (this.visible) {
        this.innerVideoUrl = value || "";
        this.isVideoReady = false;
      }
    },
  },
  methods: {
    closeVideo() {
      this.stopVideo();
      this.dialogVisible = false;
    },
    handleClose() {
      this.stopVideo();
    },
    handleClosed() {
      this.innerVideoUrl = "";
      this.isVideoReady = false;
    },
    handleVideoReady() {
      this.isVideoReady = true;
    },
    handleVideoReset() {
      this.isVideoReady = false;
    },
    stopVideo() {
      const video = this.$refs.videoPlayer;
      if (video && typeof video.pause === "function") {
        video.pause();
        video.currentTime = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pop-video-modal {
  position: relative;
  z-index: 0;
}

::v-deep .pop-video-dialog {
  width: 100vw;
  margin-top: 0 !important;
  background: transparent;
  box-shadow: none;
}

::v-deep .pop-video-dialog .el-dialog__header {
  display: none;
  padding: 0;
}

::v-deep .pop-video-dialog .el-dialog__body {
  padding: 0;
}

.cover-video {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #000000;
  z-index: 1000;

  .pop {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .pop-video {
    position: absolute;
    left: 50%;
    top: 50%;
    width: min(96vw, 1400px);
    max-height: 92vh;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;

    video {
      width: 100%;
      max-height: 92vh;
      object-fit: contain;
      display: block;
      opacity: 0;
      transition: opacity 0.12s linear;
    }

    video.is-ready {
      opacity: 1;
    }
  }

  .error-icon {
    position: absolute;
    @media (min-width: 767px) {
        left: 95%;
    }
    @media (max-width: 767px) {
        left: 88%;
    }
    top: 2%;
    font-size: 30px;
    color: #818181;

    &:hover {
      color: #fff;
    }
  }
}
</style>
